import { VDLLevel0Table } from '@VDL/components/VDLLevel0Table/VDLLevel0Table';
import { VDLLevel0GraphTable } from '@VDL/components/VDLLevel0Table/VDLLevel0GraphTable';

import type { VDLLevel0Type } from '@VDL/types/VDLLevel0Type';

interface VDLLevel0Props {
  type: VDLLevel0Type;
  isEditGraph: boolean;
}

export const VDLLevel0 = ({ type, isEditGraph }: VDLLevel0Props) => {
  switch (type) {
    case 'table':
      return <VDLLevel0Table />;
    case 'graph':
      return <VDLLevel0GraphTable isEdit={isEditGraph} />;
  }
};
